// extracted by mini-css-extract-plugin
export default {"wrapper":"CommentsList_wrapper__591n4","pagination":"CommentsList_pagination__eKjuE","loadMore":"CommentsList_loadMore__9rOUo"};